import type { IconData } from '@stacksjs/iconify-core'

export const handAwesome: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10.665 9.905h1.53v1.52h-1.53ZM9.145 28.2V12.955h1.52v-1.53h-1.52V9.9h-6.1v21.33h6.1v-1.52H12.2V28.2ZM7.615 16H6.1v-3.04h1.52Zm4.58-7.615h1.52v1.52h-1.52Zm1.52-6.1h1.52v6.1h-1.52Zm1.52 10.67h1.53v1.52h-1.53Zm0-12.19h3.05v1.52h-3.05Zm1.53 10.66h1.52v1.53h-1.52Zm0 6.1h1.52v3.05h-1.52Zm0 4.57h1.52v3.05h-1.52Zm1.52-19.81h1.52v1.52h-1.52Zm0 7.62h1.52v1.52h-1.52Zm1.52-6.1h1.53v6.1h-1.53Zm0 7.62h7.62v1.53h-7.62Zm1.53 16.77h-1.53v1.52h-7.61v1.52h12.19v-1.52h-3.05zm-3.05-3.05v3.05h1.52v-1.53h6.1v1.53h1.52v-3.05zm6.1 3.05h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M27.425 15.995h-7.62v-3.04h-1.52v4.57h9.14v3.05h-9.14v1.52h9.14v3.05h1.53v-12.19h-1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default handAwesome
